import { refineProps } from '@fullcalendar/core';
import '../ambient';
var RESOURCE_RELATED_PROPS = {
    resourceId: String,
    resourceIds: function (items) {
        return (items || []).map(function (item) {
            return String(item);
        });
    },
    resourceEditable: Boolean
};
export function parseEventDef(def, props, leftovers) {
    var resourceRelatedProps = refineProps(props, RESOURCE_RELATED_PROPS, {}, leftovers);
    var resourceIds = resourceRelatedProps.resourceIds;
    if (resourceRelatedProps.resourceId) {
        resourceIds.push(resourceRelatedProps.resourceId);
    }
    def.resourceIds = resourceIds;
    def.resourceEditable = resourceRelatedProps.resourceEditable;
}
